<sb-section-toolbar class="mb-md">
  {{ 'Personal notes' | translate }}
  @if (permissions.canEdit) {
    <a
      section-toolbar-actions
      sb-button
      color="primary"
      [routerLink]="['', { outlets: { modal: ['employee-note', employeeId] } }]"
    >
      <sb-icon name="file-regular" />
      {{ 'Add note' | translate }}
    </a>
  }
</sb-section-toolbar>

@if (loading) {
  <sb-loading-state class="py-2xl" />
} @else if (notes.length === 0) {
  <sb-card>
    <sb-empty-state
      class="py-2xl"
      icon="file-regular"
      [title]="'No notes found' | translate"
      [description]="'Start adding them now' | translate"
    />
  </sb-card>
} @else {
  <div sbTableContainer>
    <table sbTable>
      <thead>
        <tr sbTableRow>
          <th sbTableHeaderCell>{{ 'Date' | translate }}</th>
          <th sbTableHeaderCell>{{ 'Note' | translate }}</th>
          <th sbTableHeaderCell></th>
        </tr>
      </thead>
      <tbody>
        @for (note of notes; track note.id) {
          <tr sbTableRow>
            <td sbTableCell>{{ note.date | localeDate }}</td>
            <td sbTableCell data-hj-suppress>{{ note.note }}</td>
            <td sbTableCell align="right" class="whitespace-nowrap">
              @if (permissions.canEdit) {
                <button
                  [routerLink]="['', { outlets: { modal: ['employee-note', employeeId, note.id] } }]"
                  sb-icon-button
                  color="transparent"
                  [sbTooltip]="'Edit' | translate"
                  [attr.aria-label]="'Edit' | translate"
                >
                  <sb-icon name="pencil-regular" />
                </button>
              }
              @if (permissions.canDelete) {
                <button
                  sb-icon-button
                  color="transparent"
                  [sbTooltip]="'Delete' | translate"
                  [attr.aria-label]="'Delete' | translate"
                  sbActionConfirm
                  (confirmed)="deleteNote(note)"
                >
                  <sb-icon name="delete-2-regular" />
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
